import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static values = {
    show: Boolean,
    removeOnClose: Boolean,
    reposition: Boolean,
  }

  connect() {
    if (typeof $ !== 'undefined') {
      this._initModal()
    } else {
      this._waitForJQuery()
    }
  }

  disconnect() {
    if (this._jqueryInterval) {
      clearInterval(this._jqueryInterval)
      this._jqueryInterval = null
    }
    if (this._jqueryTimeout) {
      clearTimeout(this._jqueryTimeout)
      this._jqueryTimeout = null
    }
  }

  _waitForJQuery() {
    this._jqueryInterval = setInterval(() => {
      if (typeof $ !== 'undefined') {
        clearInterval(this._jqueryInterval)
        this._jqueryInterval = null
        if (this._jqueryTimeout) {
          clearTimeout(this._jqueryTimeout)
          this._jqueryTimeout = null
        }
        this._initModal()
      }
    }, 50)

    this._jqueryTimeout = setTimeout(() => {
      if (this._jqueryInterval) {
        clearInterval(this._jqueryInterval)
        this._jqueryInterval = null
      }
      console.warn('modal_controller: jQuery not available after 5s, modal will not initialize')
    }, 5000)
  }

  _initModal() {
    // hide any existing modals
    $('.modal.show').modal('hide')

    if (this.repositionValue) {
      // move this element to the body if it isn't already there
      if (this.element.parentElement !== document.body) {
        document.body.appendChild(this.element)
        return
      }
    }

    // set this controller element to a modal
    $(this.element).modal({
      show: this.showValue
    })

    // if removeOnClose is set to true
    if (this.removeOnCloseValue) {
      // watch for the hidden event
      $(this.element).on('hidden.bs.modal', () => {
        // delete this controller from the DOM
        this.element.remove()
      })
    }
  }

  // these haven't been used or tested
  // show() {
  //   this.element.modal('show')
  // }

  // hide() {
  //   this.element.modal('hide')
  // }
}
